<template>
  <p id="event-time">
      {{ displayTime }}
  </p>
</template>

<script>
import { differsFromBrowser } from '../wrestling/event_time_zone';

export default {
name: 'event-time',
props: [
  'startAt',
  'endAt',
  'allDay',
  'forPaidSession',
  // Optional IANA zone of the event's location. When its clock differs from
  // the viewer's, times read on the location's clock with a zone label.
  'timeZone',
],
data() {
  return {
    displayTime: '',
  };
},
created() {
  const vm = this;

  let start;
  let end;
  let zoneLabel = '';

  if (vm.allDay) {
    const ambiguousStart = vm.startAt.split('T')[0];
    const ambiguousEnd = vm.endAt.split('T')[0];
    start = moment(ambiguousStart);
    end = moment(ambiguousEnd);
    
    // Only subtract 1 day for single-day events (stored with end = start + 1)
    if (end.diff(start, 'days') === 1) {
      end = end.subtract(1, 'day');
    }
  } else if (differsFromBrowser(vm.timeZone, vm.startAt)) {
    start = moment.tz(vm.startAt, vm.timeZone);
    end = moment.tz(vm.endAt, vm.timeZone);
    zoneLabel = ` ${start.format('z')}`;
  } else {
    start = moment(vm.startAt);
    end = moment(vm.endAt);
  }

  const multiDay = end.diff(start, 'days') >= 1;
  // todo DRY this up
  if (vm.allDay) {
    if (vm.forPaidSession) {
      vm.displayTime = `${start.format('ddd MMM Do')} to ${end.format('ddd MMM Do')}`;
      return;
    }

    if (multiDay) {
      vm.displayTime = `All day ${start.format('ddd MMM Do')} to ${end.format('ddd MMM Do')}`;
      return;
    }

    vm.displayTime = `All day ${start.format('ddd MMM Do')}`;
  } else {
    if (multiDay) {
      vm.displayTime = `${start.format('ddd MMM Do h:mm a')} to ${end.format('ddd MMM Do h:mm a')}${zoneLabel}`;
      return;
    }

    vm.displayTime = `${start.format('ddd MMM Do, h:mm a')} to ${end.format('h:mm a')}${zoneLabel}`;
  }
},
};
</script>
